import { isDevelopment } from '@myre/common-conf';
import { languages } from '@myre/common-i18n';
import { AvatarComponent } from '@myre/ui-primitive-components';
import { browserDetection, TranslatePipe } from '@myre/ui-primitive-core';
import {
  NavbarComponent,
  NavbarDropdownComponent,
  NavbarDropdownItemComponent,
  NavbarLogoComponent,
  NavbarMenuComponent,
  NavbarMenuItemComponent,
} from '@myre/ui-primitive-navbar';

import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  HostListener,
  inject,
  NgZone,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { clamp } from 'lodash-es';
import { noop } from 'rxjs';

import { getPictureUrl } from './helper';
import { InAppNavbarComponent } from './shared/in-app-navbar/in-app-navbar.component';

@Component({
  selector: 'myre-connected',
  templateUrl: './connected.component.html',
  styleUrls: ['./connected.component.scss'],
  imports: [
    AsyncPipe,
    AvatarComponent,
    NavbarComponent,
    NavbarDropdownComponent,
    NavbarDropdownItemComponent,
    NavbarLogoComponent,
    NavbarMenuComponent,
    NavbarMenuItemComponent,
    RouterOutlet,
    TranslatePipe,
  ],
})
export class ConnectedComponent extends InAppNavbarComponent {
  public isDesktop: boolean = browserDetection.isDesktop;

  private readonly _ngZone = inject(NgZone);
  private readonly _changeDetectorRef = inject(ChangeDetectorRef);
  private _nextIndex: number = 0;
  private _konamiSeq: string[] = [
    'ArrowUp',
    'ArrowUp',
    'ArrowDown',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight',
    'ArrowLeft',
    'ArrowRight',
    'b',
    'a',
  ];

  private _wordsList: string[] = [
    "C'est du devops y'a rien de cohérent",
    'Je vais enfin avoir du taff',
    'Sur facebook jsuis dans des groupes pour faire des confitures, enfin bref ...',
    "C'est quoi la lettre hash ?",
    'Haha je pense avoir compris',
    "j'organise la réunion mais je ne connais pas le contexte",
  ];

  @HostListener('window:keydown', ['$event'])
  public handleKeyDown(event: KeyboardEvent): void {
    if (event.key === this._konamiSeq[this._nextIndex]) {
      this._nextIndex++;

      if (this._nextIndex >= this._konamiSeq.length) {
        this._nextIndex = 0;

        alert(
          this._wordsList[Math.floor(Math.random() * this._wordsList.length)],
        );
      }
    } else {
      this._nextIndex = 0;

      if (
        isDevelopment() &&
        event.ctrlKey &&
        event.shiftKey &&
        event.code.includes('Digit')
      ) {
        // Make the Digit 1 key as the first index of the lang array
        const digit = parseInt(event.code.slice(-1)) - 1;

        this.changeLang(
          Object.keys(languages)[
            clamp(digit, 0, Object.keys(languages).length - 1)
          ],
        );
      }
    }
  }

  @HostListener('window:resize.out-zone')
  public detectChanges(): void {
    if (browserDetection.isDesktop === this.isDesktop) {
      return;
    }

    this.isDesktop = browserDetection.isDesktop;

    this._ngZone.run(() => {
      this._changeDetectorRef.detectChanges();
    });
  }

  public override get baseUrl(): string {
    return '/me';
  }

  public signOut(): void {
    this._authService.logout().subscribe(noop);
  }

  public getAvatarUrl(path: string): string {
    return getPictureUrl(path);
  }
}
